import images from "../../assets";
import { PrimaryButton } from "../button";
import { Popconfirm } from "antd";

export default function ChangeRequestBox(props) {
  return (
    <div {...props} className="w-[49%]">
      <div className="w-full p-4 bg-white rounded-tl-2xl rounded-tr-2xl border-l border-r border-t border-primary50 flex-col justify-start items-start gap-4 inline-flex">
        <h3 className="self-stretch text-[#222222] text-sm font-semibold font-['Poppins'] leading-tight">
          {props.heading}
        </h3>
        <div className="self-stretch justify-center items-center gap-6 inline-flex">
          <div className="grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
            <p className="text-center text-[#222222] text-sm font-normal font-['Poppins'] leading-tight">
              {props.userdatatitle}
            </p>
            {props.userinputdata}
          </div>
          <div className="w-6 h-6 relative">
            <img src={images.ColorRightArrow} alt="img" />
          </div>
          <div className="grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
            <p className="text-center text-[#222222] text-sm font-normal font-['Poppins'] leading-tight">
              {props.requesteddatatitle}
            </p>
            {props.userrequestdata}
          </div>
        </div>
        {props.children}
        {/* <PrimaryButton
          style={{
            width: "100%",
            height: "48px",
            fontSize: "14px",
            background: "#310048",
          }}
          text={"View Document"}
          iconalign="left"
          icon={images.eyeIcon}
        /> */}
      </div>
      <div className="w-full p-4 bg-[#f5f6f7] rounded-b-2xl justify-center items-center gap-5 flex">
        <Popconfirm
          title={props?.approvetext}
          description={props?.approvedesc}
          onConfirm={() => props?.handleUpdate("approved")}
          okText="Yes"
          cancelText="No"
        >
          <PrimaryButton
            style={{
              width: "50%",
              height: "48px",
              fontSize: "14px",
              background: "#17c964",
            }}
            text={"Approve"}
            iconalign="left"
            icon={images.checkWhiteIcon}
          />
        </Popconfirm>

        <Popconfirm
          title={props?.rejecttext}
          description={props?.rejectdesc}
          onConfirm={() => props?.handleUpdate("rejected")}
          okText="Yes"
          cancelText="No"
        >
          <PrimaryButton
            style={{
              width: "50%",
              height: "48px",
              fontSize: "14px",
              background: "#f31260",
            }}
            text={"Reject"}
            iconalign="left"
            icon={images.rejectWhiteIcon}
          />
        </Popconfirm>
      </div>
    </div>
  );
}
